import { useEffect } from 'react'
import { useRegisterSW } from 'virtual:pwa-register/react'

export function PwaStatus() {
  const {
    offlineReady: [offlineReady, setOfflineReady],
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW()

  useEffect(() => {
    if (!offlineReady || needRefresh) return
    const timeout = window.setTimeout(() => setOfflineReady(false), 5000)
    return () => window.clearTimeout(timeout)
  }, [needRefresh, offlineReady, setOfflineReady])

  if (!offlineReady && !needRefresh) return null

  return (
    <aside className="update-toast" role="status" aria-live="polite">
      <p>{needRefresh ? '新版本已经准备好。' : '最近一期已可离线阅读。'}</p>
      <div>
        {needRefresh && <button type="button" onClick={() => void updateServiceWorker(true)}>更新</button>}
        <button type="button" onClick={() => { setOfflineReady(false); setNeedRefresh(false) }}>关闭</button>
      </div>
    </aside>
  )
}
